var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Artikel Gruppe Erstellen\n        ")]),_vm._v(" "),_c('v-card-text',[_c('BundleItemGroupForm',{attrs:{"type":'edit',"form":_vm.form}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }